import { Typography, Box, Link, Fade } from '@mui/material';
import { MediaNormal } from '@/components/app/media';
import { ImageList, ImageListItem } from '@mui/material';
import { useShadowUrgesQuery } from '@/schema';
import { useNavigate } from 'react-router-dom';
import { SpecialBox } from '@/components/public/special-box';

export default function ShadowRecommend() {
  const navigate = useNavigate();
  const { data, loading, error } = useShadowUrgesQuery();

  return (
    <Box padding={0}>
      <Box
        paddingY={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography component="span" variant="h6">
          最新发布
        </Typography>
        <Link
          onClick={() => navigate('/shadow-home')}
          color="textSecondary"
          variant="caption"
          style={{ cursor: 'pointer' }}
        >
          更多
        </Link>
      </Box>

      {data?.shadow_urges.length ? (
        <ImageList rowHeight="auto" cols={4}>
          {data.shadow_urges.map((shadow, index: number) => {
            return (
              <Fade
                key={index}
                in={!!data.shadow_urges.length}
                style={{ transformOrigin: '0 0 0' }}
                timeout={index * 500}
              >
                <ImageListItem cols={1}>
                  <MediaNormal
                    {...shadow}
                    onClickRoot={() => navigate(`/shadow/${shadow.id}`)}
                    onClickAuthor={() =>
                      navigate(`/profile/${shadow.author.username}`)
                    }
                  />
                </ImageListItem>
              </Fade>
            );
          })}
        </ImageList>
      ) : (
        <SpecialBox
          loading={loading}
          error={!!error}
          loadingNode={
            <ImageList rowHeight="auto" cols={4}>
              {[0, 0, 0, 0, 0, 0, 0, 0].map((_, index: number) => {
                return (
                  <ImageListItem key={index} cols={1}>
                    <MediaNormal loading />
                  </ImageListItem>
                );
              })}
            </ImageList>
          }
          placeholder
          placeholderNode={
            <ImageList rowHeight="auto" cols={4}>
              {[0, 0, 0, 0, 0, 0, 0, 0].map((_, index: number) => {
                return (
                  <ImageListItem key={index} cols={1}>
                    <MediaNormal loading />
                  </ImageListItem>
                );
              })}
            </ImageList>
          }
        />
      )}
    </Box>
  );
}
